export enum bahai_statuscode {
  Upcoming = 200630000,
  ActionNeeded = 200630001,
  Completed = 200630002,
}
